<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '600px', maxWidth: '90vw' }"
  [breakpoints]="{ '768px': '95vw' }"
  styleClass="redirect-confirmation-dialog"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header">
    <h2 class="dialog-title">{{ 'contribute.redirect.dialog.title' | translateLang }}</h2>
  </ng-template>

  <div class="dialog-content">
    <p class="giving-to-label">{{ 'contribute.redirect.dialog.giving_to' | translateLang }}</p>
    <div class="charity-block">
      <p class="charity-name">{{ charityName }}</p>

      <!-- Commented out as per POR-6112 requirement. Preserved in case this logic is still needed. -->
      <!-- @if (fundName && fundName !== charityName) {
        <p class="fund-name">{{ fundName }}</p>
      } -->
        
    </div>

    @if (logoUrl) {
    <div class="organization-logo-container">
      <img [src]="logoUrl" [alt]="organizationName" class="organization-logo" />
    </div>
    }

    <div class="redirect-description">
      <p>{{ redirectMessage | translateLang }}</p>
    </div>

    <div class="warning-box">
      <app-icon name="exclamation-outline" [size]="32" class="warning-icon" />
      <span>{{ 'contribute.redirect.allow_popups' | translateLang }}</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button type="button" class="dialog-button dialog-button--cancel" (click)="onCancel()">
        {{ 'contribute.redirect.dialog.edit_donation' | translateLang }}
      </button>
      <button type="button" class="dialog-button dialog-button--confirm" (click)="onConfirm()">
        {{ 'common.confirm' | translateLang }}
        <app-icon name="chevron-right" [size]="16" />
      </button>
    </div>
  </ng-template>
</p-dialog>
